// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"239":"b3ea364617853712","290":"ee3b49379a75a406"}[chunkId] + ".css";
};